/** @graphql cc **/

import gql from 'graphql-tag';

export const GrantAccessDialogLoaderQuery = gql`
	query GrantAccessDialogLoaderQuery($contentId: ID!, $accountId: ID!) {
		singleContent(id: $contentId) {
			id
			title
		}
		user: confluence_atlassianUser(id: $accountId) {
			id
			displayName
			photos {
				value
				isPrimary
			}
		}
	}
`;
